class LaunchPopup extends HTMLElement {
  constructor() {
    super();
    this.storageKey = this.dataset.storageKey;
    this.triggerMode = this.dataset.trigger || 'immediate';
    this.delayMs = parseInt(this.dataset.delayMs, 10) || 400;
    this.scrollPercent = parseInt(this.dataset.scrollPercent, 10) || 0;
    this.closeButton = this.querySelector('.launch-popup__close');
    this.actionButton = this.querySelector('.launch-popup__button');
    this.overlay = this.querySelector('.launch-popup__overlay');
    this.previouslyFocused = null;
    this.triggered = false;

    this.onKeydown = this.onKeydown.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.maybeShow = this.maybeShow.bind(this);

    if (this.alreadySeen()) return;

    this.closeButton?.addEventListener('click', this.dismiss.bind(this));
    this.actionButton?.addEventListener('click', this.dismiss.bind(this));
    this.overlay?.addEventListener('click', this.dismiss.bind(this));

    if (this.triggerMode === 'delayed') {
      // Apparition discrète : au premier des deux événements, délai écoulé
      // ou pourcentage de scroll atteint.
      this.delayTimer = setTimeout(this.maybeShow, this.delayMs);
      window.addEventListener('scroll', this.onScroll, { passive: true });
    } else {
      // Laisse la page s'installer avant d'afficher le pop-up.
      window.requestAnimationFrame(() => {
        setTimeout(this.show.bind(this), this.delayMs);
      });
    }
  }

  onScroll() {
    if (this.triggered) return;
    var scrollable = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollable <= 0) return;
    var scrolledPercent = (window.scrollY / scrollable) * 100;
    if (scrolledPercent >= this.scrollPercent) {
      this.maybeShow();
    }
  }

  maybeShow() {
    if (this.triggered) return;
    this.triggered = true;
    clearTimeout(this.delayTimer);
    window.removeEventListener('scroll', this.onScroll);
    this.show();
  }

  alreadySeen() {
    try {
      return localStorage.getItem(this.storageKey) === 'true';
    } catch (e) {
      return false;
    }
  }

  markAsSeen() {
    try {
      localStorage.setItem(this.storageKey, 'true');
    } catch (e) {
      // localStorage indisponible (navigation privée, quota...) : on abandonne silencieusement.
    }
  }

  show() {
    this.previouslyFocused = document.activeElement;
    this.hidden = false;
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', this.onKeydown);
    (this.closeButton || this).focus();
  }

  dismiss() {
    this.triggered = true;
    clearTimeout(this.delayTimer);
    window.removeEventListener('scroll', this.onScroll);
    this.hidden = true;
    document.body.style.overflow = '';
    document.removeEventListener('keydown', this.onKeydown);
    this.markAsSeen();
    if (this.previouslyFocused && typeof this.previouslyFocused.focus === 'function') {
      this.previouslyFocused.focus();
    }
  }

  onKeydown(event) {
    if (event.key === 'Escape') this.dismiss();
  }
}

customElements.define('launch-popup', LaunchPopup);
